/* src/app/modules/shared/components/column/column-label/column-label.component.scss */
app-column-label {
  display: contents;
}
/*# sourceMappingURL=column-label.component.css.map */
